import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import Typography from 'material-ui/Typography'
import {Button} from '../../../components'
import {paymentMethod as text} from '../text'

const styles = {
  messageWrapper: {
    marginTop: 50,
    textAlign: 'center',
  },
  messageBody: {
    maxWidth: 400,
    margin: '10px auto 50px auto',
  },
}

const NoCards = ({classes, addCard}) => (
  <div className={classes.messageWrapper}>
    <img
      src={'/assets/noCards.png'} alt='card'
      width={100} height={100} style={{objectFit: 'scale-down', marginBottom: 25}}
    />
    <Typography variant={'headline'} align={'center'} gutterBottom={true}>
      {text.emptyList.body1}
    </Typography>
    <Typography variant="body1" gutterBottom align={'center'} className={classes.messageBody}>
      {text.emptyList.body1}
    </Typography>
    <Button variant="primary" onClick={() => addCard()}>{text.emptyList.button}</Button>
  </div>
)

NoCards.propTypes = {
  addCard: PropTypes.func.isRequired,
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(NoCards)



// WEBPACK FOOTER //
// ./src/sections/profile/components/NoCards.jsx